// @flow

import 'firebase/auth'
import 'firebase/database'
import './index.less'

import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie'
import { useDispatch, useSelector } from 'react-redux'
import {SET_IS_LOADING} from '../../store/actions.js'
import { Link, withRouter } from 'react-router-dom'
import { signInWithFacebook, signInWithGoogle } from '~utils/social'
import { LOGIN_USER } from '~state/user/queries'
import client from '../../services/api'

// Components
import Button from '~button'
import Facebook from '~images/facebook-login.svg'
import Google from '~images/google-login.svg'
import { Input } from 'antd'
import { RouterHistory } from 'react-router-dom'
import firebase from 'firebase/app'
import { store } from 'react-notifications-component'
import { successNotification, errorNotification } from './loginNotitfications'

type PropsType = {
  history: RouterHistory,
  onLogin?: Function
}

const LoginForm = ({ history, onLogin }: PropsType) => {
  const dispatch = useDispatch()
  const [disabledLoginBtn, setDisabledLoginBtn] = useState(true)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const domain = process.env.NODE_ENV === 'development' ? 'localhost' : '.mudey.pt'

  const signInWithEmailAndPassword = async () => {
    setDisabledLoginBtn(true)
    dispatch({type:SET_IS_LOADING,payload:true})
    try {
      dispatch({ type: 'LOADING' })
      await firebase.auth().signInWithEmailAndPassword(email, password)
      const user = firebase.auth().currentUser
      if (user) {
        const token = await user.getIdToken()
        Cookies.set('MUDEY_token', token, { domain: domain }, { expires: 1 }, { sameSite: 'strict' }, { secure: true })
        Cookies.set(
          'MUDEY_uuid',
          user.uid,
          { domain: domain },
          { expires: 1 },
          { sameSite: 'strict' },
          { secure: true }
        )
        Cookies.set(
          'MUDEY_email',
          user.email,
          { domain: domain },
          { expires: 1 },
          { sameSite: 'strict' },
          { secure: true }
        )

        const companyId = Cookies.get('MUDEY_company', { domain: domain }) || 'Mudey'
        const managerId = Cookies.get('MUDEY_manager', { domain: domain }) || ''

        const { data } = await client.query({
          query: LOGIN_USER,
          fetchPolicy: 'no-cache',
          variables: {
            companyId: companyId,
            managerId: managerId
          }
        })

        Cookies.set(
          'MUDEY_name',
          data.userLogin.firstName,
          { domain: domain },
          { expires: 1 },
          { sameSite: 'strict' },
          { secure: true }
        )
        Cookies.set(
          'MUDEY_company',
          data.userLogin.companyId,
          { domain: domain },
          { expires: 1 },
          { sameSite: 'strict' },
          { secure: true }
        )
        Cookies.set(
          'MUDEY_manager_handler',
          data.userLogin.managerId,
          { domain: domain },
          { expires: 1 },
          { sameSite: 'strict' },
          { secure: true }
        )
        await dispatch({
          type: 'LOGIN',
          payload: {
            token,
            user: {
              email: user.email,
              name: data.userLogin.firstName,
              uuid: data.userLogin.uuid
            }
          }
        })
        store.addNotification(successNotification)
        onLogin && onLogin()
      } else {
        setDisabledLoginBtn(false)
        dispatch({ type: 'LOGOUT' })
      }
    } catch (error) {
      dispatch({type:SET_IS_LOADING,payload:false})
      store.addNotification(errorNotification)
      setDisabledLoginBtn(false)
    }
  }

  useEffect(() => {
    if (email !== '' && password !== '') {
      setDisabledLoginBtn(false)
    }
  }, [email, password])

  const handleKeypress = (e: any) => {
    if (e.keyCode === 13 || e.which == 13) {
      signInWithEmailAndPassword()
    }
  }
  return (
    <div className="login__container">
      <div className="login">
        <h3>Email</h3>
        <Input
          className="input-login"
          name="name"
          onChange={({ target: { value } }: any) => setEmail(value)}
          placeholder="email"
          size="large"
          onKeyPress={handleKeypress}
        />
        <h3>Password</h3>
        <Input.Password
          name="password"
          onChange={({ target: { value } }: any) => setPassword(value)}
          placeholder="password"
          size="large"
          type="password"
          onKeyPress={handleKeypress}
        />
        <Button
          disabled={disabledLoginBtn}
          color="purple"
          onClick={signInWithEmailAndPassword}
          style={{
            background: disabledLoginBtn ? '#dedede' : null
          }}>
          Entrar
        </Button>
        <Link to="/forgot">Esqueceste a tua password</Link>
        <div className="google-container">
          <span className="google social" onClick={signInWithGoogle}>
            <img src={Google} />
          </span>
          <span className="facebook social" onClick={signInWithFacebook}>
            <img src={Facebook} />
          </span>
        </div>
      </div>
    </div>
  )
}

LoginForm.defaultProps = {
  onLogin: () => true
}

export default withRouter(LoginForm)
